var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { decodeSceneJsonDto } from '@seddi/scene';
import { produce } from 'immer';
import { setSceneDesc, setStyleRegions, setStyleSceneDesc, updateScene } from '@/store/appSlice';
export function setScene(dispatch, scene) {
    setSceneDesc(scene);
    dispatch(updateScene());
}
export function setStyleSceneFromStyleAggregatorData(dispatch, data, hideTearAwayLabel, useBrandLogos) {
    return __awaiter(this, void 0, void 0, function* () {
        // Decode binary buffers.
        let scene = decodeSceneJsonDto(data.scene);
        // Remove unnecesary entities.
        scene.children = scene.children.filter(e => {
            if (e.components.avatar || e.components.mesh)
                return false;
            return true;
        });
        // TOOD: Domain logic
        if (hideTearAwayLabel || !useBrandLogos) {
            // TODO: Why would you use here a produce instead of in-place mutation?
            scene = produce(scene, draft => {
                draft.children.forEach(child => {
                    var _a, _b;
                    if ((_b = (_a = child.components) === null || _a === void 0 ? void 0 : _a.garmentPiece) === null || _b === void 0 ? void 0 : _b.logos) {
                        child.components.garmentPiece.logos = child.components.garmentPiece.logos.filter(logo => {
                            if (hideTearAwayLabel && logo.isTearAwayLabel) {
                                return false;
                            }
                            if (!useBrandLogos && logo.isBrandLogo) {
                                return false;
                            }
                            return true;
                        });
                    }
                });
            });
        }
        // Store the base scene (without logos) for the viewer to compose with logos.
        setStyleSceneDesc(scene);
        // Set scene immediately so Viewer can mount before waitForSceneReady (which needs viewerRef).
        // AppViewer.hooks will recompose with logos when sceneIsLoading becomes false.
        setScene(dispatch, scene);
        // Store styleRegions in Redux; logos are set by the page. AppViewer composes the scene via viewerScene.
        dispatch(setStyleRegions(data.styleRegions));
    });
}
